import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { EditUserPayload, User } from '../user.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { UsersService } from '../users.service';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, Subject, catchError, distinctUntilChanged, finalize, map, of, switchMap, takeUntil, tap } from 'rxjs';
import { atLeastOneFieldValidator } from 'src/app/utils/common/validators/at-least-one-field';
import { DirectiiService } from '../../directii/directii.service';
import { CompartimenteService } from '../../compartimente/compartimente.service';
import { FunctiiService } from '../../functii/functii.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { completeNameValidator } from 'src/app/shared/validators/complete-name';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    userTypes: Generic[] = this.data.userTypes;
    directiiActive: Generic[] = this.data.directiiActive;
    compartimenteActive!: Generic[];
    functiiActive!: Generic[];

    private editDestroy$ = new Subject<void>();

    filteredDirectii: any[] = this.data.directiiActive;
    directiiControl = new FormControl();

    filteredCompartimente: any[] = [];
    compartimenteControl = new FormControl();

    filteredFunctii: Generic[] = [];
    functiiControl = new FormControl();

    options: { key: string; value: boolean }[] = [
        { key: 'Da', value: true },
        { key: 'Nu', value: false },
    ];

    defaultParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    token!: string;
    isLoading = false;
    dataLoaded: boolean = false;
    form: any;
    // form: FormGroup = new FormGroup(
    //     {
    //         name: new FormControl(this.data.data.name, [Validators.required, completeNameValidator()]),
    //         slug: new FormControl(this.data.data.slug, []),
    //         username: new FormControl(this.data.data.username, [Validators.required]),
    //         email: new FormControl(this.data.data.email, [Validators.required, Validators.email]),
    //         user_type_id: new FormControl(this.data.data.user_type_id, [Validators.required, notDefaultValidator('-1')]),
    //         telefon_work: new FormControl(this.data.data.telefon_work, []),
    //         dgitl_avantax_user_id: new FormControl(this.data.data.dgitl_avantax_user_id, []),
    //         notificari: new FormControl(this.data.data.notificari, [Validators.required]),
    //         id_sesizare_departament: new FormControl(this.data.data.id_sesizare_departament, [Validators.required, notDefaultValidator('-1')]),
    //         id_sesizare_compartiment: new FormControl(this.data.data.id_sesizare_compartiment ? this.data.data.id_sesizare_compartiment : -1, []),
    //         functie_id: new FormControl(this.data.data.functie_id ? this.data.data.functie_id : '-1', [Validators.required, notDefaultValidator('-1')]),
    //     },
    //     { validators: atLeastOneFieldValidator('email', 'username') }
    // );

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<EditUserComponent>,
        public usersService: UsersService,
        public directiiService: DirectiiService,
        public compartimenteService: CompartimenteService,
        public functiiService: FunctiiService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.usersService.setToken(token);
        });
    }

    ngOnInit() {
        this.renderFieldsSearch();
        this.loadFunctiiActive();
        this.getUserDetails();

        if (this.data.data.id_sesizare_departament) {
            this.loadCompartimenteActive(this.data.data.id_sesizare_departament);
        }
    }

    ngOnDestroy(): void {
        this.editDestroy$.next();
        this.editDestroy$.complete();
    }

    getUserDetails() {
        this.isLoading = true;
        this.usersService.getUsersById(this.data.data.id_user).pipe(
            finalize(() => {
                this.isLoading = false;
            })
        )
            .subscribe((res: any) => {
                if (res && res.data) {
                    this.loadFormWithData(res.data);
                } else {
                    // Handle error or unexpected response format
                }
            });
    }

    loadFormWithData(data: any) {
        // how can i load the from on page if this function/form group renders after i receive success on page

        this.data.data = data // regroup data variable on component
        this.form = new FormGroup(
            {
                name: new FormControl(this.data.data.name, [Validators.required, completeNameValidator()]),
                slug: new FormControl(this.data.data.slug, []),
                username: new FormControl(this.data.data.username, [Validators.required]),
                email: new FormControl(this.data.data.email, [Validators.required, Validators.email]),
                user_type_id: new FormControl(this.data.data.user_type_id, [Validators.required, notDefaultValidator('-1')]),
                telefon_work: new FormControl(this.data.data.telefon_work, []),
                dgitl_avantax_user_id: new FormControl(this.data.data.dgitl_avantax_user_id, []),
                notificari: new FormControl(this.data.data.notificari, [Validators.required]),
                id_sesizare_departament: new FormControl(this.data.data.id_sesizare_departament, [Validators.required, notDefaultValidator('-1')]),
                id_sesizare_compartiment: new FormControl(this.data.data.id_sesizare_compartiment ? this.data.data.id_sesizare_compartiment : -1, []),
                functie_id: new FormControl(this.data.data.functie_id ? this.data.data.functie_id : -1, [Validators.required, notDefaultValidator('-1')]),
            },
            { validators: atLeastOneFieldValidator('email', 'username') }
        );
        this.dataLoaded = true
    }

    renderFieldsSearch() {
        this.directiiControl.valueChanges.pipe(
            takeUntil(this.editDestroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredDirectii = this.directiiActive;
                    return of(this.directiiActive);
                }
                return this.filterDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.compartimenteControl.valueChanges.pipe(
            takeUntil(this.editDestroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCompartimente = this.compartimenteActive;
                    return of(this.compartimenteActive);
                }
                return this.filterCompartimente(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCompartimente = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.functiiControl.valueChanges.pipe(
            takeUntil(this.editDestroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredFunctii = this.functiiActive;
                    return of(this.functiiActive);
                }
                return this.filterFunctii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredFunctii = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiActive.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    onDirectieSelectClosed() {
        const selectedValue = this.directiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDirectii.some(directie =>
                directie.id === this.form.get('id_sesizare_departament')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiControl.setValue(null);
                this.filteredDirectii = this.directiiActive;
                this.editDestroy$.next();
                this.editDestroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDirectieChange(directieId: number): void {
        this.form.controls['id_sesizare_compartiment'].patchValue(-1);

        if (directieId == -1) {
            this.compartimenteActive = [];
            this.filteredCompartimente = [];
            return;
        }

        if (directieId) {
            this.loadCompartimenteActive(directieId);
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isLoading = true;

        let compartimenteObservable$ = directieId
            ? this.compartimenteService.getCompartimenteByDirectieId(directieId)
            : this.compartimenteService.getCompartimenteActive();

        compartimenteObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isLoading = false;
            })
        ).subscribe({
            next: (compartimente) => {
                this.compartimenteActive = [...compartimente];
                this.filteredCompartimente = [...compartimente];
            },
            error: (err) => {
                console.log(err);
                this.filteredCompartimente = [];
            },
        });
    }

    filterCompartimente(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.compartimenteActive.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    onCompartimentSelectClosed() {
        const selectedValue = this.compartimenteControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCompartimente.some(compartiment =>
                compartiment.id === this.form.get('id_sesizare_compartiment')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteControl.setValue(null);
                this.filteredCompartimente = this.compartimenteActive;
                this.editDestroy$.next();
                this.editDestroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    loadFunctiiActive() {
        this.isLoading = true;
        this.functiiService
            .getFunctiiActive()
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.functiiActive = [...res];
                    this.filteredFunctii = [...res];
                },
                error: (err) => {
                    console.log(err);
                    this.functiiActive = [];
                    this.filteredFunctii = [];
                },
            });
    }

    filterFunctii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.functiiActive.filter(functie =>
            this.normalizeString(functie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    onFunctieSelectClosed() {
        const selectedValue = this.functiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredFunctii.some(functie =>
                functie.id === this.form.get('functie_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.functiiControl.setValue(null);
                this.filteredFunctii = this.functiiActive;
                this.editDestroy$.next();
                this.editDestroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    submitForm() {
        this.isLoading = true;

        const {
            name,
            username,
            email,
            user_type_id,
            functie_id,
            dgitl_avantax_user_id,
            notificari,
            telefon_work,
            public_view,
            id_sesizare_compartiment,
            id_sesizare_departament,
            slug,
        } = this.form.value as User;

        const updatedUser: EditUserPayload = {
            id_user: this.data.data.id_user,
            name,
            username,
            email,
            user_type_id,
            functie_id,
            dgitl_avantax_user_id,
            notificari,
            telefon_work,
            public_view,
            id_sesizare_compartiment,
            id_sesizare_departament,
            slug,
        };

        this.usersService
            .updateUser(updatedUser)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let msg;
            try {
                // try to catch the message from server
                msg = res.error.errors.message[0];
            } catch (error) {
                // controll output message
                msg = helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        }
    }
}
